import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
export function Hero() {
  const {
    scrollY
  } = useScroll();
  const y = useTransform(scrollY, [0, 1000], [0, 300]);
  const opacity = useTransform(scrollY, [0, 500], [1, 0]);
  return <section className="relative h-screen w-full overflow-hidden flex items-center justify-center" dir="rtl" data-id="element-60">
      {/* Parallax Background */}
      <motion.div className="absolute inset-0 z-0 bg-hero-gradient bg-cover bg-center" style={{
      y
    }} data-id="element-61" />

      {/* Content */}
      <motion.div className="relative z-10 text-center px-6 max-w-4xl mx-auto flex flex-col items-center" style={{
      opacity
    }} initial={{
      opacity: 0,
      y: 30
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 1.5,
      ease: 'easeOut',
      delay: 0.2
    }} data-id="element-62">
        <motion.div initial={{
        scaleX: 0
      }} animate={{
        scaleX: 1
      }} transition={{
        duration: 1.5,
        delay: 0.8,
        ease: 'easeInOut'
      }} className="w-24 h-[1px] bg-gold mb-8 origin-center" data-id="element-63" />

        <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl text-cream leading-tight mb-6 font-light" data-id="element-64">
          מטבח של אש,
          <br data-id="element-65" />
          יין וזיכרון
        </h1>

        <p className="text-cream/70 font-sans text-lg md:text-xl max-w-xl mx-auto mb-12 font-light tracking-wide" data-id="element-66">
          חוויה קולינרית המשלבת טכניקות מסורתיות עם חומרי גלם מקומיים, באווירה
          אינטימית ומוקפדת.
        </p>

        <a href="#reservation" className="group relative inline-flex items-center justify-center px-8 py-4 font-sans text-sm tracking-widest uppercase text-cream overflow-hidden border border-white/20 hover:border-gold transition-colors duration-500" data-id="element-67">
          <span className="relative z-10 group-hover:text-espresso transition-colors duration-500" data-id="element-68">
            הזמן שולחן
          </span>
          <div className="absolute inset-0 h-full w-full bg-gold scale-x-0 group-hover:scale-x-100 origin-right transition-transform duration-500 ease-out" data-id="element-69" />
        </a>
      </motion.div>

      {/* Scroll Cue */}
      <motion.div className="absolute bottom-12 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-4" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 2,
      duration: 1
    }} data-id="element-70">
        <span className="text-cream/50 font-sans text-xs uppercase tracking-widest" data-id="element-71">
          גלה עוד
        </span>
        <motion.div className="w-[1px] h-16 bg-gradient-to-b from-gold to-transparent" animate={{
        scaleY: [1, 1.5, 1],
        opacity: [0.5, 1, 0.5],
        y: [0, 10, 0]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-72" />
      </motion.div>
    </section>;
}